function cov_1bewvppl5c() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/TrashFilled.tsx";
  var hash = "977e9da5aca2d494f71fc25964e31b97f39eb671";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/TrashFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "977e9da5aca2d494f71fc25964e31b97f39eb671"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bewvppl5c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1bewvppl5c();
var Icon = (cov_1bewvppl5c().s[0]++, {
  name: 'trash-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.54728 5.75L7.33159 3.91996C7.84372 2.72499 9.01872 1.9502 10.3188 1.9502H14.1812C15.4813 1.9502 16.6563 2.72499 17.1684 3.91996L17.9527 5.75H20C20.6904 5.75 21.25 6.30964 21.25 7C21.25 7.69036 20.6904 8.25 20 8.25H4C3.30964 8.25 2.75 7.69036 2.75 7C2.75 6.30964 3.30964 5.75 4 5.75H6.54728ZM9.62945 4.90476C9.74763 4.62899 10.0188 4.4502 10.3188 4.4502H14.1812C14.4812 4.4502 14.7524 4.62899 14.8706 4.90476L15.2328 5.75H9.2672L9.62945 4.90476Z\" fill=\"currentColor\"/>\n  <path d=\"M19.3141 9.25H5.18594L5.65656 18.6623C5.74304 20.392 7.17066 21.75 8.9025 21.75H15.5975C17.3293 21.75 18.757 20.392 18.8435 18.6623L19.3141 9.25Z\" fill=\"currentColor\"/>"
});
export default Icon;